import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, initializeAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBUd69YbeQefvVeDSBDR0LbNBqe1oEpqKc',
  authDomain: 'api-project-294081325808.firebaseapp.com',
  databaseURL: 'https://api-project-294081325808.firebaseio.com',
  projectId: 'api-project-294081325808',
  storageBucket: 'api-project-294081325808.appspot.com',
  messagingSenderId: '294081325808',
  appId: '1:294081325808:web:91da76c3b125bdf632b035',
  measurementId: 'G-MZYRF5ETYE',
};

const app = initializeApp(firebaseConfig);
const analyticsApp = initializeAnalytics(app);
function screenTracking(screen) {
  // app.analytics().logEvent('rjsApp_screen_view', { screen_view: screen });
  // console.log("Update firebase with screen:", screen);
  logEvent(analyticsApp, 'rjsApp_screen_view', { firebase_screen: screen });
}

function logsEvent(event, eventParams) {
  // app.analytics().logEvent(event);
  // console.log("Update firebase with event", event);
  logEvent(analyticsApp, event, eventParams);
}

export { logsEvent, screenTracking };
